import { TypedDocumentNode, gql } from "@apollo/client";

import { StackTaskRun } from "shared/Stack/useSearchTasks/gql";
import { Maybe, QueryStackArgs, Run, Stack, StackTasksArgs } from "types/generated";

export type { StackTaskRun };

export type ListTasksData = {
  stack: Maybe<
    Pick<Stack, "id" | "canWrite" | "lockedBy"> & {
      blocker: Pick<Run, "id"> | null;
      tasks: StackTaskRun[];
    }
  >;
};

export const LIST_TASKS: TypedDocumentNode<ListTasksData, QueryStackArgs & StackTasksArgs> = gql`
  query ListTasks($id: ID!, $before: ID) {
    stack(id: $id) {
      id
      blocker {
        id
      }
      canWrite
      lockedBy
      tasks(before: $before) {
        id
        command
        commit {
          hash
          url
        }
        createdAt
        state
        triggeredBy
        type
      }
    }
  }
`;
